import { SampleSizeVariables, SetValueFunction } from "./onchange_callbacks";

type MissionUSPackType =
    | "LUG"
    | "FLAT"
    | "EURO"
    | "RPC_FLAT"
    | "RPC";

const MISSION_US_SAMPLE_SIZES: Record<
    MissionUSPackType,
    Partial<Record<number, number>>
> = {
    LUG: {
        96: 384,
        84: 336,
        70: 280,
        60: 240,
        48: 192,
        40: 160,
        36: 144,
        32: 128,
        28: 144,
    },
    FLAT: {
        70: 280,
        60: 240,
        48: 192,
        40: 160,
        36: 144,
        32: 128,
    },
    EURO: {
        84: 315,
        70: 245,
        60: 225,
        48: 180,
        40: 150,
        36: 135,
        32: 115,
    },
    RPC_FLAT: {
        70: 245,
        60: 225,
        48: 180,
        40: 150,
        36: 135,
        32: 115,
    },
    RPC: {
        84: 315,
        70: 245,
        60: 225,
        48: 180,
        40: 150,
        36: 135,
        32: 115,
    },
};

export const setMissionUSSampleSizeAvocado = (
    { box_weight, box_size }: SampleSizeVariables,
    setValue: SetValueFunction
): void => {
    if (!box_weight || !box_size) {
        return;
    }

    const sampleSize = MISSION_US_SAMPLE_SIZES[box_weight as MissionUSPackType]?.[box_size];

    if (sampleSize) {
        setValue("sample_size", sampleSize);
    } else {
        // Default to 100
        setValue("sample_size", 100);
    }
};


export const setSampleSizeMangoMissionUS = ({ piece_count, number_of_boxes }: { piece_count: number; number_of_boxes: number }, setValue: SetValueFunction): void => {
    if (!piece_count || !number_of_boxes) {
        return;
    }
    setValue("sample_size", Math.round(piece_count * number_of_boxes * 0.07));
};

export type DefectGroupCallbackParams = {
    check: any;
    input_group: { group_total: number; [key: string]: any };
    frequency: { [key: string]: number };
    setCheckValue: (field: string, value: any) => void;
};

type MetaFormCallbackParams = {
    field: string;
    value: any;
    setValue: SetValueFunction;
};

/**
 * For Mission US inbound checks, EYE - Fruit:
 * Sets bulk_edit to 3 when any value is filled out for maturity_D_4 or maturity_D_5
 */
export const setBulkEditForMissionUSStage4Or5 = (params: DefectGroupCallbackParams | MetaFormCallbackParams): void => {
    if ("setValue" in params) {
        params.setValue(params.field, params.value);
        return;
    }

    const { check, frequency, setCheckValue } = params;
    if (frequency?.maturity_D_4 > 0 || frequency?.maturity_D_5 > 0) {
        // * Set to 3 if not already set to 3
        if (String(check?.use_bulk_edit) !== "3") {
            setCheckValue("use_bulk_edit", 3);
        }
    }
};
